<template>
  <div class="pb-8">
    <div v-if="selectedAppointment && selectedAppointment.ClinicDetail" class="bg-white px-3 py-2">
      <span>Rumah Sakit</span>
      <h5 class="font-rubik-medium mb-0 mt-2 text-uppercase">
        {{ selectedAppointment.ClinicDetail ? selectedAppointment.ClinicDetail.ClinicName : '-' }}
      </h5>
    </div>
    <countdown-book />
    <h5 class="font-rubik-medium px-3 pt-2 pb-1 m-0">
      Detail Konsultasi
    </h5>
    <div v-if="userIsLoggedIn && userData" class="bg-white px-2 mx-3 border-r7px py-2 mt-2 box-shadow">
      <span>Profil Pasien</span>
      <h5 class="font-rubik-medium mb-0 mt-2 text-capitalize">
        {{ userData.Fullname }}
      </h5>
    </div>
    <div>
      <div
        class="bg-white px-2 mx-3 border-r7px py-2 mt-2 d-flex align-items-center justify-content-between cursor-pointer position-relative box-shadow"
        @click="backToHome"
      >
        <div>
          <span class="text-soft-grey-netral">Tanggal & Waktu</span>
          <h5 v-if="selectedAppointment" class="font-rubik-medium mb-0 mt-2">
            {{ $moment.unix(selectedAppointment.Start).format('dddd, DD MMM YYYY') }} |
            {{ $moment.unix(selectedAppointment.Start).format('HH:mm') }} -
            {{ $moment.unix(selectedAppointment.Start + selectedAppointment.ConversationTime).format('HH:mm') }}
            {{ $getLocalTimeZone($moment.unix(selectedAppointment.Start).format('Z')) }}
          </h5>
        </div>
        <div class="position-absolute right-3 top-65">
          <img
            width="40px"
            src="@/assets/icon/edit_icon_new.svg"
            alt=""
            class="cursor-pointer"
          >
        </div>
      </div>
      <div id="modal-list-appointment" class="modal modal-timeout max-w-600 mx-auto">
        <div class="modal-content modal-list">
          <div class="popup-header text-center">
            <img src="@/assets/icon/sad-icon.svg">
            <h2 class="text-uppercase mt-3 mb-4">Jadwal dokter sudah tidak tersedia</h2>
            <p class="mb-3">Silahkan pilih di waktu yang tersedia</p>
          </div>
          <div class="modal-body">
            <calendar-picker v-if="showListAppointment" :data-select="dataSelect" class="bg-soft-grey" />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="bg-white px-2 mx-3 border-r7px py-2 mt-2 d-flex align-items-center justify-content-between box-shadow"
      >
        <div>
          <span class="text-soft-grey-netral">Durasi Konsultasi</span>
          <h5 class="font-rubik-medium mb-0 mt-2 text-uppercase">
            {{ selectedAppointment.ConversationTime / 60 }} Menit
          </h5>
        </div>
        <img src="@/assets/img/videocall_new.png" class="icon-videocall">
      </div>
    </div>
    <template v-if="userData && userData.Birthdate">
      <div v-if="!appointmentBook" class="text-center my-5">
        <b-spinner label="Spinner" />
      </div>
      <div v-if="userIsLoggedIn && userData && appointmentBook" class="px-2 pb-2 mx-3 mt-2 border-r7px bg-white position-relative box-shadow" :class="{'border-red': !canPay}">
        <div v-if="!isNotValidRemainingYesdokBalance && isYesdokBalance && !totalPrice" class="bg-disabled" />
        <div class="pt-2 position-relative" :class="(selectPayment && compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isDisabledVA) ? 'disabled-va' : ''">
          <span class="text-soft-grey-netral">Metode Pembayaran</span>
          <div class="choose-payment">
            <div
              v-if="!selectPayment"
              class="font-rubik-medium mt-1 cursor-pointer"
              @click="handleListPayment()"
            >
              Pilih Metode Pembayaran
            </div>
            <p v-else class="font-rubik-medium mb-0 text-uppercase pt-2">
              {{ selectPayment.paymentType === cardType ? selectPayment.Type : selectPayment.paymentType === 'midtrans' ? 'Metode Pembayaran Lain' : selectPayment.Name }}
            </p>
            <div class="position-absolute right-3 top-65" :class="!isDisabledEdit ? 'box-icon-payment' : ''">
              <!-- <img
                v-if="selectPayment"
                :width="compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA) ? '45px' : '30px'"
                :src="(compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA)) ? require('@/assets/img/bca.png') : selectPayment.Type.toLowerCase() === 'mastercard' ? require('@/assets/img/mastercard.png') : selectPayment.paymentType === cardType ? require('@/assets/img/visa.png') : selectedPayment.ImageUrl"
                alt=""
              > -->
              <font-awesome-icon
                v-if="isDisabledEdit"
                icon="chevron-right"
                size="lg"
                class="cursor-pointer"
                @click="handleListPayment()"
              />
            </div>
          </div>
        </div>

        <div class="box-notice">
          <div v-if="selectPayment && compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA)">
            <div v-if="isActive" class="box-info-countdown">
              <p class="mb-0 text-white">
                Pembayaran VA Anda telah kedaluarsa.
              </p>
              <b-button
                class="px-4 mt-3 text-white"
                @click="handleListPayment()"
              >
                Pilih Metode Pembayaran
              </b-button>
            </div>
          </div>
          <div v-if="showInfo" class="position-absolute right-3 box-info">
            <img src="@/assets/icon/icon-info-i-red.svg" @click="onShow">
          </div>
        </div>
        <div v-if="selectPayment && compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isShowCountdown" class="boxCountdown text-center mt-2 border-r7px">
          <span>Lakukan pembayaran dalam waktu {{ hour }}:{{ minute }}:{{ second }}</span>
        </div>
      </div>
      <template v-if="userData.YesdokBalance !== 0">
        <template v-if="userIsLoggedIn && userData && appointmentBook">
          <div v-show="isNotValidRemainingYesdokBalance && !selectPayment" class="mx-3 mt-1 text-red" style="font-size: 14px">
            Saldo Yesdok tidak mencukupi silahkan pilih metode pembayaran
          </div>
          <saldo-yesdok
            :saldo-yesdok="userData.YesdokBalance"
            :is-yesdok-balance="isYesdokBalance"
            :is-disabled="isYesdokBalanceDisabled"
            @change-saldo-yesdok="onChangeYesdokBalance($event)"
          />
        </template>
      </template>
      <div
        class="bg-white px-2 mx-3 border-r7px py-2 mt-2 d-flex flex-column box-shadow"
      >
        <span class="mb-2 text-soft-grey-netral">Makin hemat pakai promo</span>
        <div class="d-flex justify-content-between w-100">
          <input
            v-model="inputPromo"
            type="text"
            placeholder="Masukkan Kode"
            class="form-control mr-2"
            style="border-color: #E6E6E6;"
            @input="inputPromo = inputPromo.toUpperCase()"
            @keyup.enter="fetchPromo"
          >
          <button class="btn btn-blue-yd" :disabled="!inputPromo || (usedPromo && inputPromo === usedPromo.ID.toUpperCase())" @click="fetchPromo">
            Gunakan
          </button>
        </div>
        <div v-if="invalidPromo.type" class="d-flex justify-content-between align-items-center border-r7px px-3 py-2 mt-2" :class="invalidPromo.type === 'warning' ? 'bg-soft-orange' : 'bg-soft-red'" style="font-size: 14px;">
          <div class="d-flex">
            <img v-if="invalidPromo.type === 'warning'" src="@/assets/icon/guard-warning.svg" alt="icon">
            <img v-else src="@/assets/icon/cross-danger.svg" alt="icon">
            <div class="ml-2">
              {{ invalidPromo.message }} <b>{{ invalidPromo.additionalMessage }}</b>
            </div>
          </div>
          <div class="remove-button" @click="removePromo()">
            Hapus
          </div>
        </div>
        <template v-if="usedPromo">
          <div class="d-flex justify-content-between align-items-center bg-soft-green border-r7px p-3 mt-2" style="font-size: 14px;">
            <div class="d-flex">
              <img src="@/assets/icon/icon-checklist-green.svg" alt="" class="mr-2">
              <div>
                Kode promo sudah terpasang: <strong class="text-uppercase">{{ usedPromo.Title.ID }}</strong>
              </div>
            </div>
            <div class="remove-button" @click="removePromo()">
              Hapus
            </div>
          </div>
        </template>
        <div ref="promoContainer" class="container-box overflow-auto pb-2 mt-2">
          <template v-if="listPromo.length">
            <div v-for="(data, index) in listPromo" :key="index" class="card-box" :class="{ 'disabled': !isPromoValid(data) }">
              <div class="card-distance px-2 py-2 cursor-pointer" @click="showDetailPromo(data)">
                <h5 class="font-rubik-medium text-black text-overflow-elipsis">
                  {{ data.Title.ID }}
                </h5>
                <div class="text-black">
                  Kode Promo: <span class="font-rubik-medium text-uppercase">{{ data.ID }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-1 text-orange-2">
                  <div class="text-xs d-flex align-items-center">
                    <img src="@/assets/icon/icon-timer-orange.svg" alt="" class="mr-1">Berlaku hingga {{ $moment.unix(data.EndPromo).format('DD MMM YYYY') }}
                  </div>
                  <button class="btn btn-sm btn-blue-yd" :disabled="isPromoUsed(data) || !isPromoValid(data)" @click.stop="usePromo(data)">
                    {{ isPromoUsed(data) ? 'Digunakan' : 'Gunakan' }}
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px">
              <img src="@/assets/icon/promo-disabled.svg" alt="promo disabled">
              <div>Belum ada promo yang tersedia</div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="appointmentBook" class="mx-3 mt-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="font-17px text-soft-grey-netral">Biaya Konsultasi</span>
          <div class="d-flex justify-content-center align-items-center">
            <span v-if="selectedAppointment.Price === 25000" class="bg-warning promo-label my-1 mx-2">Promo</span>
            <span v-if="selectedAppointment" class="d-table-cell font-22px font-rubik-medium">
              Rp{{ selectedAppointment.Price | formatMoney }}
            </span>
          </div>
        </div>
        <div v-if="isYesdokBalance && userData.YesdokBalance != 0" class="d-flex justify-content-between align-items-center mt-2">
          <span class="font-17px text-soft-grey-netral">Pakai Saldo YesDok</span>
          <div class="d-flex justify-content-center align-items-center">
            <span class="d-table-cell font-22px font-rubik-medium">
              -Rp{{ usedYesdokBalance | formatMoney }}
            </span>
          </div>
        </div>
        <div v-if="usedPromo" class="d-flex justify-content-between align-items-center mt-2">
          <span class="font-17px text-soft-grey-netral">
            Pakai Promo {{ usedPromo.Title.ID }}
          </span>
          <div class="d-flex justify-content-center align-items-center">
            <span class="d-table-cell font-22px text-green">
              -Rp{{ promoAmount | formatMoney }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <span class="font-17px text-soft-grey-netral">
            Biaya Transaksi
            <template v-if="userIsLoggedIn && appointmentBook">
              <span v-if="selectPayment">
                <span>
                  {{ (compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA)) ? 'Bank' : (selectPayment.Type.toLowerCase() === 'mastercard' || selectPayment.paymentType === cardType) ? 'Kartu Kredit' : selectPayment.Type.toLowerCase() === 'midtrans' ? '' : 'E-Wallet' }}
                </span>
                <img
                  :width="(compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA)) ? '45px' : selectPayment.Type.toLowerCase() === 'ovo' ? '23px' : '30px'"
                  :src="(compareString(selectPayment.Type, paymentType.PAYMENT_TYPE_VA_BCA)) ? require('@/assets/img/bca.png') : selectPayment.Type.toLowerCase() === 'mastercard' ? require('@/assets/img/mastercard.png') : selectPayment.paymentType === cardType ? require('@/assets/img/visa.png') : selectedPayment.ImageUrl"
                  alt=""
                >
              </span>
            </template>
          </span>
          <span v-if="!selectPayment && (userData.YesdokBalance - selectedAppointment.Price) > minSplit" class="font-22px text-black">
            -
          </span>
          <span v-else class="font-22px text-black">
            <span v-if="!selectPayment">
              -
            </span>
            <span v-else>
              Rp{{ taxPrice | formatMoney }}
            </span>
          </span>
        </div>
        <div class="border-b-2 mb-3 border-dotted-blue py-2" />
        <div class="d-flex justify-content-between align-items-center">
          <span class="font-17px text-soft-grey-netral">Total Biaya</span>
          <span v-if="totalPrice === 0" class="font-22px text-green font-rubik-medium">
            -
          </span>
          <span v-else class="font-22px text-green font-rubik-medium">
            Rp{{ totalPrice | formatMoney }}
          </span>
        </div>
        <div v-if="isYesdokBalance && (userData.YesdokBalance - selectedAppointment.Price + promoAmount) > 0">
          <div class="mt-3 d-flex justify-content-between align-items-center">
            <span class="font-17px text-premier-blue">Sisa Saldo Yesdok</span>
            <span class="font-22px text-green">
              Rp{{ userData.YesdokBalance - selectedAppointment.Price + promoAmount | formatMoney }}
            </span>
          </div>
          <div class="mt-3 desc-saldo-yesdok p-2 position-relative">
            <p class="mb-0">
              Sisa Saldo YesDok otomatis masuk<br>Saldo YesDok <img src="@/assets/img/saldo-yesdok-blue.png">, gunakan untuk konsultasi berikutnya
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-if="userIsLoggedIn && userData && userData.Birthdate">
      <div class="text-center mt-5">
        <b-alert
          :show="balanceDismissCountDown"
          variant="warning"
          @dismissed="balanceDismissCountDown=0"
          @dismiss-count-down="balanceCountDownChanged"
        >
          Saldo Anda tidak mencukupi
        </b-alert>
        <b-button
          v-if="appointmentBook"
          size="lg"
          class="border-r25px px-6 font-rubik-medium btn-blue-yd"
          :disabled="!canPay"
          @click="checkBalance"
        >
          Bayar &nbsp;<font-awesome-icon icon="chevron-right" class="mr-n2" /> <font-awesome-icon icon="chevron-right" />
        </b-button>
      </div>
    </template>
    <template v-else-if="userData && !userData.Birthdate">
      <div class="bg-light-yellow text-center text-uppercase mt-5 mx-2 py-3 px-5 font-rubik-medium">
        <h4>Data pribadi diperlukan untuk memulai konsultasi dengan dokter</h4>
        <b-button
          size="lg"
          block
          variant="success-2"
          class="border-r25px font-rubik-medium"
          @click="goToRegister"
        >
          Lengkapi Profil <font-awesome-icon icon="chevron-right" class="mr-n2" /> <font-awesome-icon icon="chevron-right" />
        </b-button>
      </div>
    </template>
    <template v-else>
      <p class="text-center px-sm-5 px-4 mt-4 mb-5">
        Untuk membuat janji konsultasi dengan dokter, Anda harus melengkapi data diri Anda terlebih dahulu.
      </p>
      <div class="d-flex flex-sm-row-reverse flex-wrap flex-sm-nowrap justify-content-around align-items-center mx-3">
        <b-button size="lg" variant="success-2" class="border-r25px w-100" @click="handleContinue">
          Lanjutkan
        </b-button>
        <b-button size="lg" variant="outline-primary-3" class="border-r25px w-100 mr-sm-3 mt-sm-0 mt-3" @click="handleGoBack">
          Kembali
        </b-button>
      </div>
    </template>

    <b-modal
      ref="modalPaymentRS"
      body-class="modal-payment-rs"
      modal-class="modal-bottom backdrop-primary"
      centered
      hide-header
      hide-footer
    >
      <template v-if="selectedAppointment">
        <div v-if="selectedAppointment.ClinicDetail" class="header-img">
          <img :src="`${selectedAppointment.ClinicDetail.ClinicLogo}?w=120`" alt="" width="150">
        </div>
        <div v-if="selectedAppointment.ClinicDetail" class="content px-2 align">
          <h4 class="text-center font-rubik-medium mb-3">
            {{ selectedAppointment.ClinicDetail.ClinicName || '-' }}
          </h4>
          <p class="font-rubik-medium">
            {{ selectedAppointment.ClinicDetail.Type === 'HOSPITAL' ? 'Rumah Sakit' : 'Klinik' }} ini:
          </p>
          <div v-if="!selectedAppointment.ClinicDetail.IsAllowedConsultationICD10" class="my-3 d-flex align-items-center">
            <img src="@/assets/icon/icon-not-summary.svg" alt="" class="mr-2">
            <span>Tidak Menyediakan Rangkuman Konsultasi</span>
          </div>
          <div v-if="!selectedAppointment.ClinicDetail.IsVideoRecorded" class="my-3 d-flex align-items-center">
            <img src="@/assets/icon/icon-not-video.svg" alt="" class="mr-2">
            <span>Tidak Menyediakan Video Rekaman</span>
          </div>
        </div>
        <div class="mt-5 mb-3">
          <b-button size="lg" variant="success-2" class="border-r25px w-100" @click="handleButtonContinue">
            Lanjutkan
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modalPayment"
      ref="modalPayment"
      body-class="modal-payment"
      modal-class="modal-bottom backdrop-primary"
      centered
      hide-footer
      hide-header
    >
      <button type="button" aria-label="Close" class="close close-btn" @click="resetPayment">
        ×
      </button>
      <div>
        <img src="@/assets/icon/icon-guarantee.svg" width="131" alt="" class="d-block">
        <img src="@/assets/icon/img-money-back.png" alt="" class="float-right mr-n3">
      </div>
      <div>
        <div class="clearfix" />
        <h2 class="font-rubik-bold text-premier-blue">
          Jaminan uang kembali
        </h2>
        <div v-if="appointmentBook && appointmentBook.DoctorFaultRefund" class="list-info mt-3">
          <span class="position-relative">
            <img src="@/assets/icon/percentage.svg">
            <span class="position-absolute top-65 font-weight-bold text-large" :class="appointmentBook.DoctorFaultRefund === 100 ? 'left-0' : 'left-10'">{{ appointmentBook.DoctorFaultRefund }}%</span>
          </span>
          <p><strong>{{ appointmentBook.DoctorFaultRefund }}% dana pasti dikembalikan,</strong><br>Jika Dokter gagal membuat panggilan konsultasi</p>
        </div>
        <div v-if="appointmentBook && appointmentBook.PatientFaultRefund" class="list-info">
          <span class="position-relative">
            <img src="@/assets/icon/percentage.svg">
            <span class="position-absolute top-65 font-weight-bold text-large" :class="appointmentBook.PatientFaultRefund === 100 ? 'left-0' : 'left-10'">{{ appointmentBook.PatientFaultRefund }}%</span>
          </span>
          <p><strong>{{ appointmentBook.PatientFaultRefund }}% dana pasti dikembalikan,</strong><br>Jika Anda gagal menerima panggilan dari dokter</p>
        </div>
        <div class="attention text-center">
          <div class="bg-attention p-2">
            <p class="font-rubik-bold mb-0">*Diluar biaya admin</p>
            <p class="mb-0 font-rubik">Transfer Bank Rp10,000,-</p>
            <p class="mb-0 font-rubik">E-Wallet Rp2,000,-</p>
          </div>
        </div>
      </div>
      <div class="mt-5 mb-3">
        <b-button size="lg" variant="success-2" class="border-r25px w-100" :disabled="checkoutLoading" @click="handlePayButton">
          {{ checkoutLoading ? 'Loading...' : 'Saya Mengerti' }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalPaymentVA"
      body-class="modal-payment-va"
      modal-class="modal-bottom backdrop-primary"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <payment-va @closed="closeModalVA" />
    </b-modal>

    <b-modal
      id="ovoPhoneVerification"
      hide-footer
      header-class="border-0"
      centered
    >
      <label for="inputNumberOvo" class="mb-3">Masukkan nomor handphone yang terdaftar di aplikasi OVO</label>
      <input id="inputNumberOvo" v-model.trim="formOvo.phoneFormatted" class="form-control mb-3" placeholder="Masukkan nomor telepon">
      <b-button :disabled="checkoutLoading || !formOvo.phoneFormatted" block variant="success" class="border-r25px" @click="handlePayButton">
        BAYAR
      </b-button>
    </b-modal>

    <b-modal
      id="ovoWaitingVerificationModal"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Menunggu Verifikasi"
      hide-footer
      centered
      header-class="border-0"
      title-class="text-center"
      content-class="border-radius-20px"
    >
      <div class="text-center pb-3" style="position: relative">
        <img src="@/assets/img/ovo_payment.png" width="200px" alt="">
        <template v-if="OVO_VerificationStatus === 'pending'">
          <p class="mt-3">
            Kami menunggu pembayaran Anda melalui aplikasi OVO Anda dalam <span class="font-rubik-medium">{{ ovoVerificationDurationNumber }}</span> detik
          </p>
          <p class="font-rubik-medium">
            (Buka aplikasi OVO & masuk ke menu Inbox.<br> Pastikan sudah update aplikasi terbaru)
          </p>
        </template>
        <template v-else-if="OVO_VerificationStatus === 'fail'">
          <p>Pembayaran dengan OVO Gagal</p>
          <b-button block variant="outline-primary" @click="resetPayment()">
            Kembali
          </b-button>
        </template>
      </div>
    </b-modal>
    <b-modal
      id="modal-whatsapp-required"
      ref="modal-whatsapp-required"
      class="modal-whatsapp-required"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      centered
      hide-header
      hide-footer
    >
      <verification-whatsapp />
    </b-modal>

    <b-modal
      ref="modal-promo-detail"
      dialog-class="max-w-600"
      hide-header
      centered
      hide-footer
    >
      <div v-if="dataPromoModal" class="d-flex flex-column justify-content-between modal-promo-detail p-3">
        <div>
          <img
            style="width: 15px;"
            class="mb-4 cursor-pointer"
            :src="require('assets/img/close.png')"
            @click="$refs['modal-promo-detail'].hide()"
          >
          <h4 class="font-rubik-medium">
            {{ dataPromoModal.Title.ID }}
          </h4>
          <div v-html="dataPromoModal.Description.ID" />
        </div>
        <div>
          <p class="text-orange-2 text-xs">
            <img src="@/assets/icon/icon-timer-orange.svg">
            Berlaku hingga {{ $moment.unix(dataPromoModal.EndPromo).format('DD MMM YYYY') }}
          </p>
          <div class="bg-soft-grey p-3 d-flex justify-content-between">
            <div>Kode Promo: <strong class="text-uppercase text-new-blue">{{ dataPromoModal.ID }}</strong></div>
            <img
              v-if="!isCopiedToClipboard"
              src="@/assets/icon/icon-vector-copy.svg"
              alt="vector copy"
              class="cursor-pointer"
              @click="() => {
                copyToClipboard(dataPromoModal.ID)
              }"
            >
            <span v-if="isCopiedToClipboard" class="text-green">Disalin!</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import handleSelectForIpad from '@/mixins/handleSelectForIpad'
import PaymentVa from '@/components/appointment-component/PaymentVa'
import CalendarPicker from '@/components/appointment-component/CalendarPicker'
import VerificationWhatsapp from '@/components/appointment-component/VerificationWhatsapp'
import CountdownBook from '@/components/appointment-component/CountdownBook'
import SaldoYesdok from '@/components/appointment-component/SaldoYesdok'
import handleStatus from '~/mixins/handleStatus.js'
export default {
  name: 'Confirmation',
  components: {
    CalendarPicker,
    PaymentVa,
    VerificationWhatsapp,
    CountdownBook,
    SaldoYesdok
  },
  mixins: [handleSelectForIpad, handleStatus],
  data: () => ({
    hour: '00',
    minute: '00',
    second: '00',
    isShowCountdown: false,
    isDisabledPay: false,
    showInfo: false,
    isDisabledEdit: true,
    isActive: false,
    isDisabledVA: false,
    showListAppointment: false,
    userIsLoggedIn: false,
    checkoutLoading: false,
    iconSad: require('~/assets/icon/sad-icon.svg'),

    // payment
    taxPrice: 0,
    selectedPaymentIndex: null,
    selectedPayment: null,
    paymentIsLoading: false,
    dataSelect: {
      priceSelect: '',
      durationSelect: '',
      durationConversation: '',
      durationReview: ''
    },
    formOvo: {
      phone: '',
      phoneFormatted: ''
    },
    OVO_VerificationStatus: 'pending',
    ovoVerificationDurationNumber: 0,
    cardType: 'creditcard',
    balanceSelected: 0,
    balanceDismissSecs: 4,
    balanceDismissCountDown: 0,
    timerInterval: null,
    isDisabled: true,
    minSplit: -10000,
    inputPromo: '',
    dataPromoModal: null,
    invalidPromo: {
      type: '',
      message: '',
      additionalMessage: ''
    },
    isCopiedToClipboard: false
  }),
  computed: {
    checkCountdown () {
      return this.$store.state.doctor.countdownOff
    },
    countdownLeft () {
      return this.$store.state.patient.countdown
    },
    appointmentBook () {
      return this.$store.state.doctor.appointmentBook
    },
    selectPayment () {
      return this.$store.state.doctor.selectedPayment
    },
    selectedAppointment () {
      return this.$store.state.doctor.booking.selectedAppointment
    },
    userData () {
      return this.$store.state.patient.auth.userData
    },
    usedYesdokBalance () {
      if ((this.userData.YesdokBalance - (this.selectedAppointment.Price - this.promoAmount)) < 0) {
        return this.userData.YesdokBalance
      } else {
        return this.selectedAppointment.Price - this.promoAmount
      }
    },
    totalPrice () {
      const priceAfterDiscount = this.selectedAppointment.Price - this.promoAmount
      if (this.selectPayment) {
        if (this.isYesdokBalance && (this.userData.YesdokBalance - this.selectedAppointment.Price) < this.minSplit) {
          return (priceAfterDiscount + this.taxPrice) - this.userData.YesdokBalance
        } else if (this.isYesdokBalance && (this.userData.YesdokBalance - this.selectedAppointment.Price) === this.minSplit) {
          return (priceAfterDiscount - this.userData.YesdokBalance) + this.taxPrice
        } else {
          return priceAfterDiscount + this.taxPrice || 0
        }
      } else if (this.isYesdokBalance && this.userData.YesdokBalance >= this.selectedAppointment.Price - this.promoAmount) {
        return 0
      } else if (this.isYesdokBalance && (this.selectedAppointment.Price - this.userData.YesdokBalance) >= 10000) {
        return priceAfterDiscount - this.userData.YesdokBalance
      } else {
        return priceAfterDiscount
      }
    },
    paymentType () {
      return this.$store.state.paymentType
    },
    doctorData () {
      return this.$store.state.doctor.doctorData.Doctor
    },
    listPromo () {
      const list = this.$store.state.doctor.promo.list.filter(item => item.IsVisible === true)
      const sorted = this.usedPromo ? list.sort((a, b) => (a.ID === this.usedPromo.ID ? -1 : b.ID === this.usedPromo.ID ? 1 : 0)) : list
      return sorted
    },
    usedPromo () {
      return this.$store.state.doctor.promo.used
    },
    promoAmount () {
      const type = this.usedPromo ? this.usedPromo.DiscountType : null
      const maxDiscount = this.usedPromo ? this.usedPromo.MaxDiscount : 0
      if (type === 'NOMINAL') {
        return this.usedPromo.DiscountNominal
      } else if (type === 'PERCENTAGE') {
        const value = this.selectedAppointment.Price * (this.usedPromo.DiscountPercentage / 100)
        return (value < maxDiscount || maxDiscount === 0) ? value : maxDiscount
      } else {
        return 0
      }
    },
    isYesdokBalance () {
      return this.$store.state.doctor.useYesdokBalance
    },
    isNotValidRemainingYesdokBalance () {
      const remaining = (this.userData.YesdokBalance + this.promoAmount) - this.selectedAppointment.Price
      return remaining < 0 && remaining > -10000
    },
    isYesdokBalanceDisabled () {
      return this.isNotValidRemainingYesdokBalance
      // (this.selectPayment && this.usedPromo && this.selectedAppointment.Price - this.userData.YesdokBalance < 10000)
    },
    canPay () {
      if (this.selectPayment && this.compareString(this.selectPayment.Type, this.paymentType.PAYMENT_TYPE_VA_BCA) && this.isDisabledVA) {
        return false
      } else if (this.selectPayment || (this.isYesdokBalance && this.totalPrice === 0)) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    checkCountdown: {
      handler (value) {
        if (value) {
          this.showModalList('block')
        } else {
          this.showModalList('none')
        }
      }
    },
    selectedPaymentIndex (next, prev) {
      if (next !== prev) {
        this.calculateTax()
      }
    },
    'formOvo.phoneFormatted' () {
      if (this.formOvo.phoneFormatted) {
        this.formOvo.phoneFormatted = this.formOvo.phoneFormatted.replace(/-|\s/g, '')
      }
    },
    'selectedAppointment.Price' (next) {
      if (next && this.selectedPaymentIndex) {
        this.calculateTax()
      }
    },
    usedPromo (next, prev) {
      if (next !== prev && this.selectPayment) {
        this.calculateTax()
      }
      if (this.isYesdokBalance && this.isNotValidRemainingYesdokBalance) {
        this.setUseYesdokBalance(false)
      }
    },
    isYesdokBalance (val) {
      if (val && this.userData.YesdokBalance >= this.selectedAppointment.Price - this.promoAmount) {
        this.usePromo(this.usedPromo)
        this.resetPaymentMethod()
      } if (val && (this.selectPayment && this.selectPayment.Type.toUpperCase() === 'MIDTRANS')) {
        this.resetPaymentMethod()
      } else if (val && this.selectPayment && this.isNotValidRemainingYesdokBalance) {
        this.setUseYesdokBalance(false)
      }
      if (this.selectPayment) {
        this.calculateTax()
      }
      this.fetchPromo({ list: true })
    }
  },
  mounted () {
    this.checkUserIsLoggedIn()
    this.selectHandlerIpad()
    if (this.selectPayment !== null) {
      this.selectedPayment = this.$store.state.doctor.selectedPayment
      this.selectedPaymentIndex = this.$store.state.doctor.selectedPaymentIndex
      this.balanceSelected = this.$store.state.doctor.balance
      if (this.compareString(this.selectPayment.Type, this.paymentType.PAYMENT_TYPE_VA_BCA)) {
        this.fetchingCountdownVa(this.countdownLeft)
      }
    }
  },
  beforeDestroy () {
    if (this.stepComponent !== 'confirmation') {
      clearInterval(this.timerInterval)
    }
  },
  methods: {
    resetPaymentMethod () {
      this.$store.commit('doctor/SET_PAYMENT', null)
      this.$store.commit('doctor/SET_PAYMENT_INDEX', null)
      this.selectedPayment = null
      this.selectedPaymentIndex = null
    },
    calculateTax () {
      const checkoutObj = {}
      checkoutObj.Payment = this.selectPayment
      if (checkoutObj.Payment && checkoutObj.Payment.Type === 'VirtualAccount') {
        this.taxPrice = this.appointmentBook ? this.appointmentBook.VaTaxFee : 0
      } else if (checkoutObj.Payment && checkoutObj.Payment.Type === 'Midtrans') {
        this.taxPrice = 10000
      } else {
        this.taxPrice = (this.selectedAppointment.Price - this.promoAmount - (this.isYesdokBalance ? this.userData.YesdokBalance : 0)) * (this.appointmentBook ? this.appointmentBook.OthersTaxFee : 0)
      }
    },
    showModalList (val) {
      this.showListAppointment = true
      this.dataSelect.priceSelect = this.selectedAppointment.Price
      this.dataSelect.durationSelect = this.selectedAppointment.ConsultLength
      this.dataSelect.durationConversation = this.selectedAppointment.ConversationTime
      this.dataSelect.durationReview = this.selectedAppointment.ReviewTime
      const modal = document.getElementById('modal-list-appointment')
      modal.style.display = val
    },
    onShow () {
      this.isActive = !this.isActive
    },
    fetchingCountdownVa (duration) {
      let timer = duration
      this.timerInterval = setInterval(() => {
        const seconds = timer % 60
        const secondsInMinutes = (timer - seconds) / 60
        const minutes = secondsInMinutes % 60
        const hours = (secondsInMinutes - minutes) / 60
        this.hour = String(hours).padStart(2, '0')
        this.minute = String(minutes).padStart(2, '0')
        this.second = String(seconds).padStart(2, '0')
        if (hours === 0 && minutes < 30) {
          this.isShowCountdown = true
        }
        --timer
        if (minutes === 0 && seconds < 1) {
          this.taxPrice = 0
          this.isDisabledVA = true
          this.showInfo = true
          this.isDisabledEdit = false
          this.isShowCountdown = false
          this.isDisabled = true
          this.selectedPayment = null
          this.$store.commit('patient/SET_DISABLE_VA', true)
          clearInterval(this.timerInterval)
        }
      }, 1000)
    },
    handleListPayment () {
      if (this.countdownLeft !== '') {
        clearInterval(this.timerInterval)
      }
      this.$store.commit('doctor/SET_STEP', 'list-payments')
      localStorage.setItem('step', 'list-payments')
    },
    goToRegister () {
      this.$store.commit('doctor/SET_STEP', 'register')
      localStorage.setItem('step', 'register')
    },
    backToHome () {
      this.$router.push(this.$route.fullPath)
      this.$store.commit('doctor/SET_STEP', 'initial')
      localStorage.setItem('step', 'initial')
    },
    balanceCountDownChanged (dismissCountDown) {
      this.balanceDismissCountDown = dismissCountDown
    },
    handlePayButton () {
      const price = this.totalPrice
      if (this.userData.YesdokBalance >= price || this.selectedPayment) {
        this.checkoutLoading = true
        if (this.selectedPayment && this.compareString(this.selectedPayment.Type, this.paymentType.PAYMENT_TYPE_OVO)) {
          this.formOvo.phone = this.formOvo.phoneFormatted ? this.formOvo.phoneFormatted.replace('+62', '0') : null
          this.selectedPayment.ID = this.formOvo.phone
          if (!this.formOvo.phone) {
            this.checkoutLoading = false
            this.$bvModal.show('ovoPhoneVerification')
            return false
          }
          if (this.formOvo.phone.length < 10) {
            this.checkoutLoading = false
            this.paymentIsLoading = false
            this.$swal('Pembayaran Ovo Gagal', 'Periksa kembali nomor telepon anda', 'warning')
            return false
          } else {
            this.$bvModal.show('ovoWaitingVerificationModal')
            this.ovoVerificationDurationNumber = 100

            const self = this
            this.timerInterval = setInterval(function () {
              if (self.ovoVerificationDurationNumber > 0) {
                self.ovoVerificationDurationNumber--
              } else {
                clearInterval(self.timerInterval)
                self.checkoutLoading = false
                self.$swal({
                  title: '',
                  text: 'PEMBAYARAN GAGAL',
                  icon: 'error',
                  timer: 2000
                })
                self.paymentIsLoading = false
                self.resetPayment()
              }
            }, 1000)
          }
        }
        if (this.userData && this.userData.ID) {
          if (this.selectPayment && this.compareString(this.selectPayment.Type, this.paymentType.PAYMENT_TYPE_MIDTRANS)) {
            this.paymentMidtrans()
          } else {
            const payload = {
              ID: this.appointmentBook ? this.appointmentBook.ID : null,
              PaymentType: this.usingPaymentType(),
              PaymentID: this.selectedPayment && this.selectedPayment.ID ? this.selectedPayment.ID : null,
              YesDokBalance: this.isYesdokBalance ? this.usedYesdokBalance : 0,
              PaymentConsultation: this.totalPrice === 0 ? 0 : this.totalPrice - this.taxPrice,
              PatientID: this.userData.ID
            }
            this.$store.dispatch('doctor/bookingPayment', payload)
              .then((res) => {
                localStorage.setItem('public_id', this.selectedAppointment.PublicID)
                if (this.userData.YesdokBalance < price) {
                  if (this.compareString(this.selectedPayment.Type, this.paymentType.PAYMENT_TYPE_VA_BCA)) {
                    localStorage.setItem('va_id', res.TransactionID)
                    if (this.selectedAppointment.Price === 0) {
                      localStorage.setItem('step', 'payment-success')
                      return this.$store.commit('doctor/SET_STEP', 'payment-success')
                    }
                    this.hideModal('self')
                    return this.$refs.modalPaymentVA.show()
                  }
                }
                this.$swal({
                  title: 'Booking Berhasil',
                  text: '',
                  icon: 'success',
                  timer: 2000
                }).then(() => {
                  this.$store.commit('doctor/SET_BOOKING_FINISHED', true)
                  localStorage.removeItem('va_id')
                  localStorage.setItem('step', 'payment-success')
                  return this.$store.commit('doctor/SET_STEP', 'payment-success')
                })
                this.hideModal('self')
                this.checkoutLoading = false
              })
              .catch((err) => {
                this.checkoutLoading = false
                this.$swal({
                  title: 'Pembayaran Gagal',
                  text: '',
                  icon: 'error',
                  timer: 2000
                })
                this.resetPayment()
                throw new Error(err)
              })
          }
        }
      }
    },
    usingPaymentType () {
      if (this.isYesdokBalance && !this.selectPayment) { return 'YesDokBalance' }
      if (this.selectedPayment.paymentType === this.cardType) { return 'creditcard' }
      if (this.compareString(this.selectedPayment.Type, this.paymentType.PAYMENT_TYPE_LINKAJA)) { return 'LinkAja' }
      return this.selectedPayment.Type
    },
    checkBalance () {
      const price = this.selectedAppointment.Price
      if (this.userData.YesdokBalance >= price) { this.showModal('self'); return }
      if (this.selectPayment && this.balanceSelected < price) { this.balanceDismissCountDown = this.balanceDismissSecs; return }
      if (this.selectedAppointment.ClinicDetail && (!this.selectedAppointment.ClinicDetail.IsAllowedConsultationICD10 || !this.selectedAppointment.ClinicDetail.IsVideoRecorded)) {
        return this.showModal('hospital')
      } else {
        return this.showModal('self')
      }
    },
    handleButtonContinue () {
      this.hideModal('hospital')
      this.showModal('self')
    },
    closeModalVA () {
      this.checkoutLoading = false
      this.$refs.modalPaymentVA.hide()
      localStorage.removeItem('va_id')
    },
    showModal (type = 'self') {
      if (type === 'self') {
        this.$refs.modalPayment.show()
      } else {
        this.$refs.modalPaymentRS.show()
      }
    },
    hideModal (type = 'self') {
      if (type === 'self') {
        this.$refs.modalPayment.hide()
      } else {
        this.$refs.modalPaymentRS.hide()
      }
    },
    async checkUserIsLoggedIn () {
      if (localStorage.getItem('token')) {
        await this.$store.dispatch('patient/auth', localStorage.getItem('token')).then((res) => {
          this.checkingWhatsapp(res)
          if (this.$store.state.patient.auth.userData) {
            this.userIsLoggedIn = true
            this.getAppointmentBook()
            this.checkYesdokBalance()
            this.fetchPromo({ list: true })
            // revalidate promo after select payment
            if (this.selectPayment && this.usedPromo) {
              this.usePromo(this.usedPromo)
            }
          }
        }).catch((err) => {
          if (err.Message === 'TNC_CONFIRMATION') {
            this.$refs['modal-tnc-expired'].show()
          }
          throw new Error(err)
        })
      }
    },
    checkYesdokBalance () {
      if (this.userData.YesdokBalance >= this.selectedAppointment.Price) {
        if (this.isYesdokBalance === null) {
          this.setUseYesdokBalance(true)
        }
      } else if (this.userData.YesdokBalance > 0 && (this.userData.YesdokBalance - this.selectedAppointment.Price) <= this.minSplit) {
        if (this.isYesdokBalance === null) {
          this.setUseYesdokBalance(true)
        }
      }
    },
    checkingWhatsapp (res) {
      if (!res.Data) { return }
      if (!res.Data.WhatsappNumber) { return this.$refs['modal-whatsapp-required'].show() }
      if (res.Data.Status === 'PhoneVerification') {
        localStorage.setItem('step', 'register-otp')
        return this.$store.commit('doctor/SET_STEP', 'register-otp')
      }
    },
    getAppointmentBook () {
      const payload = {
        AppointmentOnlineID: this.selectedAppointment.PublicID,
        PatientID: this.$store.state.patient.auth.userData.ID,
        FacilityID: this.selectedAppointment.ClinicID || null,
        FacilityType: this.selectedAppointment.ClinicDetail ? this.selectedAppointment.ClinicDetail.Type : null
      }
      this.$store.dispatch('patient/saveBooking', payload)
        .then((res) => {
          this.$store.commit('doctor/SET_APPOINTMENT_BOOK', res)
        })
        .catch((err) => {
          if (err.Message === 'NOT_ALLOW') {
            this.$swal({
              title: 'Jadwal Dokter Sudah Tidak Tersedia',
              imageUrl: this.iconSad,
              html: 'Silahkan booking jadwal dokter yang tersedia',
              showConfirmButton: false,
              showCancelButton: true,
              cancelButtonText: 'Pilih Dokter Yang Tersedia',
              cancelButtonColor: '#024668',
              customClass: {
                container: 'alert-not-allow',
                cancelButton: 'text-uppercase btn-primary-3 btn-block',
                title: 'mb-4 text-uppercase font-rubik-medium',
                popup: 'rounded-25'
              }
            }).then((res) => {
              if (res.isDismissed) {
                return window.open(`${process.env.BASE_YD_URL}/${this.$store.state.patient.auth.userData.Language === 'ID' ? 'id' : 'en'}/doctor/list`, '_self')
              }
            })
          }
          throw new Error(err)
        })
    },
    resetPayment () {
      this.checkoutLoading = false
      this.OVO_VerificationStatus = 'pending'
      this.ovoVerificationDurationNumber = 0
      this.formOvo.phone = null
      this.formOvo.phoneFormatted = null

      this.$bvModal.hide('ovoPhoneVerification')
      this.$bvModal.hide('ovoWaitingVerificationModal')
      this.$refs.modalPayment.hide()
    },
    handleContinue () {
      this.$store.commit('doctor/SET_STEP', 'login')
      localStorage.setItem('step', 'login')
    },
    handleGoBack () {
      this.$store.commit('doctor/SET_STEP', 'initial')
      localStorage.setItem('step', 'initial')
    },
    paymentMidtrans () {
      let payloadMidtrans = {
        Amount: this.selectedAppointment.Price,
        PaymentAmount: this.selectedAppointment.Price,
        TotalPaymentAmount: this.totalPrice - this.taxPrice,
        TaxFee: this.taxPrice,
        PatientID: this.userData.ID,
        PaymentType: 'DOCTOR_SPECIALIST',
        AppointmentID: this.appointmentBook ? this.appointmentBook.ID : null
      }
      const partner = sessionStorage.getItem('partner')
      if (partner) {
        payloadMidtrans = Object.assign(payloadMidtrans, { FromPartners: partner })
      }
      this.$store.dispatch('doctor/midtransPayment', payloadMidtrans).then(async (res) => {
        if (res) {
          await localStorage.setItem('url-midtrans', res)
          window.location.href = await res
        }
      }).catch((err) => {
        this.$swal({
          title: 'Pembayaran Gagal',
          text: '',
          icon: 'error',
          timer: 2000
        })
        this.resetPayment()
        console.error('ERROR', err)
      })
    },
    showDetailPromo (data) {
      this.$refs['modal-promo-detail'].show()
      this.dataPromoModal = data
    },
    fetchPromo ({ list = false }) {
      const filter = !list ? this.inputPromo : null
      const paymentType = this.selectedPayment ? this.formatPaymentAppointment(this.selectedPayment.Type, this.selectedPayment.paymentType) : this.isYesdokBalance ? 'YESDOK_BALANCE' : null
      const payload = {
        filter,
        paymentMethod: paymentType,
        IsUsedYesdokBalance: this.isYesdokBalance
      }
      this.$store.dispatch('doctor/fetchListPromo', payload)
        .then(async (res) => {
          if (list) {
            this.$store.commit('doctor/SET_PROMO_LIST', res || [])
          } else if (res.length) {
            await this.claimPromo(res[0])
            this.usePromo(res[0])
          } else {
            this.$store.commit('doctor/SET_PROMO_USED', null)
            this.invalidPromo = {
              type: 'danger',
              message: 'Promo yang Anda cari tidak tersedia',
              additionalMessage: ''
            }
          }
        })
    },
    async claimPromo (promo) {
      if (!promo.PromoPatient) {
        await this.$store.dispatch('doctor/claimPromo', promo.ID)
        await this.fetchPromo({ list: true })
      }
    },
    async usePromo (promo) {
      const promoValid = await this.validatePromo(promo)
      if (promo.PromoPatient && promo.PromoPatient.IsUsed) {
        this.$store.commit('doctor/SET_PROMO_USED', null)
        this.invalidPromo = {
          type: 'warning',
          message: 'Maaf, kode yang Anda masukkan sudah ditukarkan sepenuhnya atau tidak valid',
          additionalMessage: ''
        }
      } else if (this.isPromoValid(promo) && promoValid) {
        this.$store.commit('doctor/SET_PROMO_USED', promo)
        this.invalidPromo = {
          type: '',
          message: '',
          additionalMessage: ''
        }
        this.inputPromo = promo.ID.toUpperCase()
        const promoContainer = this.$refs.promoContainer
        if (promoContainer) {
          promoContainer.scrollLeft = 0
        }
      } else {
        this.$store.commit('doctor/SET_PROMO_USED', null)
        this.invalidPromo = {
          type: 'warning',
          message: 'Promo yang anda pilih tidak dapat digunakan: ',
          additionalMessage: promo.Title.ID
        }
      }
    },
    async validatePromo (promo) {
      const paymentType = this.selectedPayment ? this.formatPaymentAppointment(this.selectedPayment.Type, this.selectedPayment.paymentType) : this.isYesdokBalance ? 'YESDOK_BALANCE' : null
      const payload = {
        PromoID: promo.ID,
        PaymentMethod: paymentType,
        IsUsedYesdokBalance: this.isYesdokBalance
      }
      const res = await this.$store.dispatch('doctor/validatePromo', payload)
      return res && res.IsValid
    },
    removePromo () {
      this.inputPromo = ''
      this.invalidPromo = {
        type: '',
        message: '',
        additionalMessage: ''
      }
      this.$store.commit('doctor/SET_PROMO_USED', null)
      if (this.isNotValidRemainingYesdokBalance) {
        this.setUseYesdokBalance(false)
      }
    },
    isPromoUsed (promo) {
      return this.usedPromo && this.usedPromo.ID === promo.ID
    },
    isPromoValid (promo) {
      let valid = true
      const currentTimeStamp = Math.round(new Date().getTime() / 1000)
      const isPromoTimeValid = promo.EndPromo > currentTimeStamp
      const isPriceValid = this.selectedAppointment.Price >= promo.MinPrice
      const isQuotaValid = promo.QuotaLeft > 0
      const isSplitBill = this.isYesdokBalance && this.selectedPayment
      const isUsed = promo.PromoPatient && promo.PromoPatient.IsUsed
      const isInsufficientYesdokBalance = promo.PaymentMethod && promo.PaymentMethod.includes('YESDOK_BALANCE') && this.userData.YesdokBalance + promo.DiscountNominal - this.selectedAppointment.Price < 0
      if (!isPromoTimeValid || !isPriceValid || !isQuotaValid || isSplitBill || promo.IsDisable || isUsed || isInsufficientYesdokBalance) {
        valid = false
      }
      return valid
    },
    copyToClipboard (value = '') {
      navigator.clipboard.writeText(value).then(
        () => {
          this.isCopiedToClipboard = true
          setTimeout(() => {
            this.isCopiedToClipboard = false
          }, 3000)
        },
        () => {
          alert('failed copy to clipboard!')
        }
      )
    },
    onChangeYesdokBalance (val) {
      this.setUseYesdokBalance(val)
      if (this.usedPromo) {
        this.usePromo(this.usedPromo)
      }
    },
    setUseYesdokBalance (val) {
      this.$store.commit('doctor/SET_USE_YESDOK_BALANCE', val)
    },
    formatPaymentAppointment (type, paymentType) {
      if (paymentType === 'creditcard') {
        return 'CREDITCARD'
      }
      switch (type) {
        case 'YesDokBalance':
          return 'YESDOK_BALANCE'
        case 'VirtualAccount':
          return 'VIRTUAL_ACCOUNT'
        default:
          return type ? type.toUpperCase() : null
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .box-info-countdown {
    top: -95px;
    right: 18px;
    background: #E70016;
    &::after {
      right: 3px;
      bottom: -15px;
      border-color: #E70016 transparent transparent transparent;
    }
  }

  .btn-success.disabled, .btn-success:disabled {
    background-color: #E6E6E6 !important;
    border-color: #E6E6E6 !important;
  }

  .btn-new-yd.disabled, .btn-new-yd:disabled {
    background-color: #E6E6E6 !important;
    border-color: #E6E6E6 !important;
  }

  .btn-new-yd.disabled, .btn-new-yd:disabled {
    color: #fff !important;
    background-color: transparent;
    border-color: #E6E6E6 !important;
  }

  .btn-blue-yd.disabled, .btn-blue-yd:disabled {
    color: #C2C2C2 !important;
    background-color: #E0E0E0;
    border-color: #E6E6E6 !important;
  }

  .form-control:focus {
    box-shadow: 0 0 0 0.1rem #00B5E2 !important;
  }

  .form-control.error {
    border-color: #ff0000 !important;
  }

  .modal-promo-detail {
    min-height: 529px !important;
  }

  .container-box {
    .disabled {
      div, h5, span {
        color: #E6E6E6 !important;
      }
      img {
        filter: grayscale(1);
      }
    }
  }

  .text-new-blue {
    color: #00B5E2;
  }

</style>

<style lang="scss">
$light-yellow: #FFEED1;
  .bg-light-yellow {
    background-color: $light-yellow;
  }
  .attention {
    width: 65%;
    margin: auto;
    .bg-attention {
      border-radius: 10px;
      background: rgba(174, 235, 255, 0.32);
      p {
        color: #024668;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
  .alert-not-allow {
    .swal2-header {
      img {
        width: 80px;
      }
      h2 {
        font-size: 22px !important;
      }
    }
    .swal2-actions {
      button {
        border-radius: 25px;
      }
    }
  }
  .modal-timeout {
    display: none;
    position: fixed;
    z-index: 9;
    left: 0;
    top: 0;
    max-width: 100% !important;
    margin: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    -webkit-animation-name: fadeIn;
    -webkit-animation-duration: 0.4s;
    animation-name: fadeIn;
    animation-duration: 0.4s;
    .modal-content {
      z-index: 9;
      background-color: #fefefe;
      width: 600px;
      margin: auto;
      height: 92%;
      -webkit-animation-name: slideIn;
      -webkit-animation-duration: 0.4s;
      animation-name: slideIn;
      animation-duration: 0.4s;
      .modal-body {
        padding: 2px 16px;
      }
      @media screen and (max-width: 480px) {
        width: 100%;
        position: fixed;
        bottom: 0;
      }
    }
    .popup-header {
      padding: 30px 30px 0px 30px;
      img {
        width: 75px;
      }
      h2 {
        color: #024668;
        font-weight: 600;
        font-size: 21px !important;
      }
      p {
        color: #024668;
        font-size: 17px;
      }
    }
  }
  .font-26px {
    font-size: 22px !important;
    @media screen and (min-width: 350px) {
      font-size: 24px !important;
    }
  }
  @-webkit-keyframes slideIn {
    from {bottom: -300px; opacity: 0}
    to {bottom: 0; opacity: 1}
  }
  @keyframes slideIn {
    from {bottom: -300px; opacity: 0}
    to {bottom: 0; opacity: 1}
  }
  @-webkit-keyframes fadeIn {
    from {opacity: 0}
    to {opacity: 1}
  }
  @keyframes fadeIn {
    from {opacity: 0}
    to {opacity: 1}
  }
  .bg-soft-grey {
    border-radius: 8px;
    background: #F7F7F7;
  }
  .alert-countdown {
    .swal2-popup {
      border-radius: 15px;
      .swal2-header {
        img {
          width: 80px;
        }
        h2 {
          color: #024668;
        }
      }
      .swal2-content {
        color: #024668;
        margin: 10px 0px;
      }
      .btn-ok {
        width: 125px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 25px !important;
        background: #024668 !important;
      }
    }
  }
  .box-icon-payment {
    top: 42px !important;
    right: 55px;
    @media screen and (max-width: 480px) {
      top: 36px !important;
    }
  }
  .icon-videocall {
    width: 125px;
    margin-top: -20px;
  }
  .box-info {
    top: 26px;
    @media screen and (max-width: 480px) {
      top: 20px;
    }
    img {
      width: 23px;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }
  .font-17px {
    font-size: 17px;
  }
  .bg-light-gray {
    background-color: #F3F2EF;
  }
  .disabled-va {
    opacity: 0.4;
    background: #adadad;
  }
  .border-dotted-blue {
    border-bottom: 2px dotted #024668;
  }
  .desc-saldo-yesdok {
    border-radius: 4px;
    background: #FCC401;
    p {
      img {
        width: 15px;
      }
    }
    &:after {
      border-bottom: 9px solid #FCC401;
      border-left: 9px solid rgba(0, 0, 0, 0);
      border-right: 9px solid rgba(0, 0, 0, 0);
      content: "";
      display: inline-block;
      position: absolute;
      top: -9px;
      right: 30px;
    }
  }
  .box-info-saldo {
    z-index: 1;
    margin-top: -1px;
    &:after {
      right: 10px;
    }
  }
  .modal-payment-rs {
    position: relative;
    .header-img {
      position: absolute;
      top: -2.5rem;
      left: 50%;
      transform: translate(-50%, -2rem);
      img {
        border: 1px solid #024668;
        border-radius: 4px;
      }
    }
    .content {
      margin-top: 5rem;
    }
  }
  .left-0 {
    left: 0;
  }
  .left-10 {
    left: 10px;
  }
  .top-65 {
    top: 65%;
    transform: translate(0, -65%);
  }
  .modal-payment {
    .list-info {
      display: flex;
      align-items: center;
      padding: 7px;
      margin-bottom: 10px;
      font-size: 14px;
      img {
        width: 50px;
        height: 50px;
        max-width: 50px;
        max-height: 50px;
      }
      p {
        margin: 0;
        text-align: left;
        padding-left: 1rem;
        color: #00466A;
        strong{
          color: #00466A;
        }
      }
    }
  }
  .close-btn {
    margin-top: 0 !important;
    margin-right: 0 !important;
    color: #000 !important;
    font-weight: bold;
    transition: 0.3s;

    &:hover {
      color: #024668 !important;
      opacity: 1 !important;
    }
  }
  .close {
    color: #000 !important;
  }
  .promo-label {
    display: inline-block;
    vertical-align: middle;
    font-weight: 600;
    border-radius: 3px;
    padding: 1px 7px;
    max-width: fit-content;
  }
  .saldo-yesdok {
    .box-saldo {
      height: 50px;
      line-height: 50px;
      border-radius: 20px;
      .icon-saldo {
        width: 34px;
        height: 34px;
        margin-top: 6px;
        line-height: 31px;
        position: absolute;
        border-radius: 50%;
        background: #024668;
      }
      p {
        margin-left: 44px;
      }
      .saldo {
        right: 0;
        img {
          z-index: 1;
          width: 21px;
          margin-top: -3px;
        }
      }
    }
    .border-box {
      border: 1px solid #024668;
    }
  }
  .bg-disabled {
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    opacity: 0.85;
    position: absolute;
    border-radius: 20px;
    background: #ffffff;
  }
  .border-red {
    border: 1px solid #EC1C24;
  }

  .container-box {
    white-space: nowrap;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    .card-box {
      scroll-snap-align: start;
      display: inline-block;
      background: white;
      border-radius: 7px;
      border: 0.5px solid #D8D7D5;
      box-sizing: border-box;
      margin-right: 0.5rem;
      &:last-child {
        margin-right: 0px;
      }
      width: 75%;
      @media (max-width: 430px) {
        width: 85%;
      }
      &.disabled > * {
        color: #E6E6E6 !important;
      }
    }
  }

  .bg-soft {
    &-green {
      background-color: #D4F0D4;
    }
    &-red {
      background-color: #FFF4F2;
    }
    &-orange {
      background-color: #FFF3DB;
    }
  }

  .remove-button {
    cursor: pointer;
    color: #E70016;
  }

  .text-xs {
    font-size: 12px;
  }

  .text-overflow-elipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>
